module.exports = __webpack_public_path__ + "img/9.a7312d0c.jpg";